module.exports = __webpack_public_path__ + "static/img/quizzes_bg.c1e587e1.jpg";